import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Card, CardContent, CardHeader, Typography, Box } from '@mui/material';
import { EmojiObjects as LearningIcon, School as GradeIcon, AccountBalance as SchoolIcon, LocationOn as GeographyIcon } from '@mui/icons-material';

const useStyles = makeStyles()((theme) => ({
  root: {
    maxWidth: 400,
    boxShadow: theme.shadows[3],
    height: "100%"
  },
  header: {
    backgroundColor: theme.palette.primary.light + '10',
    '& .MuiTypography-root': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  content: {
    padding: theme.spacing(3),
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  icon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  value: {
    fontWeight: 500,
  },
}));

export const UserDetails = ({ learningGeneration = "", grade = "", school = "", geographyType = "" }) => {
  const { classes } = useStyles();

  const detailsConfig = [
    {
      icon: <LearningIcon />,
      label: 'Learning Generation',
      value: learningGeneration,
    },
    {
      icon: <GradeIcon />,
      label: 'Grade',
      value: grade,
    },
    {
      icon: <SchoolIcon />,
      label: 'School',
      value: school,
    },
    {
      icon: <GeographyIcon />,
      label: 'Geography Type',
      value: geographyType,
    },
  ];

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        title={
          <Typography variant="h5" className="header-text" component="h2">
            Student Details
          </Typography>
        }
      />
      <CardContent className={classes.content}>
        {detailsConfig.map((detail, index) => (
          <Box key={index} className={classes.infoRow}>
            <Box className={classes.icon}>
              {detail.icon}
            </Box>
            <Box>
              <Typography className={classes.label}>
                {detail.label}
              </Typography>
              <Typography className={classes.value}>
                {detail.value}
              </Typography>
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};